/* eslint-disable react/no-array-index-key */
import React from 'react'
import Grid from '@material-ui/core/Grid'
import DoneAllIcon from '@material-ui/icons/DoneAll'
import Typography from '@material-ui/core/Typography'
import Alert from '../../../../../helpers/Alerts/Alert'

function AlertList({ alertList, classes, dialogHandler, alertHistory }) {
  return (
    <>
      <Grid
        container
        component="div"
        direction="column"
        className={alertHistory ? classes.alertListHeight : {}}
      >
        {alertList?.length > 0 ? (
          alertList?.map((alert, index) => (
            <Grid
              item
              key={`${alert.dockey}-${index}`}
              className={classes.fullWidth}
            >
              <Alert
                alert={alert}
                classes={classes}
                dialogHandler={dialogHandler}
              />
            </Grid>
          ))
        ) : (
          <Grid
            container
            className={classes.fullWidth}
            direction="column"
            alignItems="center"
          >
            <Grid item>
              <DoneAllIcon className={classes.doneIcon} />
            </Grid>
            <Grid item>
              <Typography align="center" variant="h5">
                You&apos;re all caught up!
              </Typography>
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  )
}

export default AlertList
